import React, { useMemo } from 'react';
import { JsonForms } from '@jsonforms/react';
import {
  materialCells,
  materialRenderers,
} from '@jsonforms/material-renderers';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

interface DeviceLevelFormProps {
  attributeIds: string[];
  deviceData: any;
  handleDeviceDataChange: any;
}

const DeviceLevelForm: React.FC<DeviceLevelFormProps> = ({
  attributeIds,
  deviceData,
  handleDeviceDataChange,
}) => {
  const dynamicDropdownRenderer = useMemo(() => {
    return (props: any) => {
      const { options, value, onChange } = props;
      return (
        <TextField
          select
          variant='outlined'
          fullWidth
          value={value}
          onChange={(event) => onChange(event.target.value)}
          {...options}
        >
          {attributeIds.map((attributeId) => (
            <MenuItem key={attributeId} value={attributeId}>
              {attributeId}
            </MenuItem>
          ))}
        </TextField>
      );
    };
  }, [attributeIds]);

  const schema = {
    type: 'object',
    required: ['attributeId', 'deviceId'],
    properties: {
      attributeId: {
        type: 'string',
        enum: attributeIds,
      },
      deviceId: {
        type: 'string',
      },
    },
  };

const uischema = {
  type: 'HorizontalLayout',
  elements: [
    {
      type: 'Control',
      scope: '#/properties/attributeId',
      options: {
        renderers: {
          select: dynamicDropdownRenderer,
        },
        required: true,
      },
    },
    {
      type: 'Control',
      scope: '#/properties/deviceId',
      label: 'Device Id',
      options: {
        required: true,
      },
    },
  ],
};

  return (
    <JsonForms
      schema={schema}
      uischema={uischema}
      data={deviceData}
      renderers={materialRenderers}
      cells={materialCells}
      onChange={handleDeviceDataChange}
    />
  );
};

export default DeviceLevelForm;
